import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconAura: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconAura"><Circle cx="12" cy="10.5" r="3" stroke="currentColor"/><Path d="M6.5 21V21.5H17.5V21C17.5 17.9624 15.0376 15.5 12 15.5C8.96243 15.5 6.5 17.9624 6.5 21Z" stroke="currentColor"/><Path d="M12.0002 1V4M5.89369 3.22228L7.82205 5.52041M2.64453 8.85042L5.59895 9.37137M3.77289 15.2502L6.37096 13.7502M18.1066 3.22228L16.1783 5.52041M21.3558 8.85042L18.4014 9.37137M20.2274 15.2502L17.6294 13.7502" stroke="currentColor"/></CentralIconBase>;
});

export default IconAura;
